import { REACT_APP_BACKEND_URL, REACT_APP_AI_API_URL } from "./config";

export const BACKEND_HOST = REACT_APP_BACKEND_URL + "/api";

export const API_API_BASE_URL = REACT_APP_AI_API_URL;

export function getImageUrl(path: string): string {
  return `${path}`;
}
